import React, { useEffect, useRef } from "react";
import p5 from "p5";
import { useSelector, useDispatch } from "react-redux";
import { drawScaleLineV2 } from "./ScaleLine";
import {
  componentHeight,
  componentWidth,
  backgroundColour,
  cascadeViewHeight,
  baseline,
  subregionGeneHeight,
} from "../constants";
import { setCladeColouring } from "../helpers/setCladeColouring";
import {
  drawTrack,
  drawPrompt,
  drawTooltip,
  drawPositionIndicator,
} from "../helpers/drawSubregionSelectionElements";
import { changeCalculatedPositions } from "../redux/reducers/calculatedPositionsSlice";

const SubregionSelection = (props) => {
  const containerRef = useRef();
  const dispatch = useDispatch();

  const Sketch = (p) => {
    let minPos, pg, selectedNodes, chunkHeight, canvasHeight;

    p.setup = () => {
      // find the smallest start position of the selected genes
      var pos = [];
      for (let i = 0; i < props.clickedGenes.length; i++) {
        pos.push(props.clickedGenes[i]["calculatedStart"]);
      }
      minPos = p.min(pos);

      // set the height vars according to view style
      if (props.viewStyle === "flat") {
        canvasHeight = subregionGeneHeight + (baseline+15);
        chunkHeight = subregionGeneHeight;
      }
      else {
          canvasHeight = cascadeViewHeight;
          chunkHeight = (cascadeViewHeight - (props.clickedGenes.length + 25)) / props.clickedGenes.length;
      }

      p.createCanvas(componentWidth, canvasHeight);
      pg = p.createGraphics(componentWidth, canvasHeight);

      p.noLoop();
    };

    p.draw = () => {
      p.background(backgroundColour);
      selectedNodes = [];
      drawSubregionSelection();
    };

    p.mouseMoved = () => {
      p.background(backgroundColour);
      p.image(pg, 0, 0);
      drawScaleLineV2(p, [], canvasHeight - 10);

      for (let i = 0; i < selectedNodes.length; i++) {
        if (
          p.mouseX >= selectedNodes[i].left - 5 &&
          p.mouseX <= selectedNodes[i].left + 5 + selectedNodes[i].width
        ) {
          if (
            p.mouseY >= selectedNodes[i].top &&
            p.mouseY <= selectedNodes[i].top + selectedNodes[i].height
          ) {
            // handle case where tooltip goes off screen on right and bottom
            var xpos, ypos;
            if (p.mouseX >= componentWidth - 150) xpos = p.mouseX - 165;
            else xpos = p.mouseX + 15;

            if (p.mouseY >= p.height - 40) ypos = p.mouseY - 75;
            else ypos = p.mouseY;

            p.image(pg, 0, 0);

            if (props.viewStyle === "flat") {
                drawPositionIndicator(p, selectedNodes[i], canvasHeight, chunkHeight, false);
                drawScaleLineV2(p, [], canvasHeight - 10);
            }
            else {
                drawPositionIndicator(p, selectedNodes[i], canvasHeight, chunkHeight, true);
                drawScaleLineV2(p, [], canvasHeight - 10);
            }

            // display repeat info tooltip
            drawTooltip(p, xpos, ypos, selectedNodes[i]);
          }
        }
      }
    };

    const drawSubregionSelection = () => {
      pg.background(backgroundColour);
      p.background(backgroundColour);

      // No genes selected -- prompt for a click
      if (
        typeof props.clickedGenes === "undefined" ||
        props.clickedGenes.length === 0
      ) {
        drawPrompt(pg, componentWidth, componentHeight);
      } else {
        for (let i = 0; i < props.clickedGenes.length; i++) {
          setCladeColouring(props.clickedGenes[i].clade, props.clade, pg);
        
          let currentYPos;
          if (props.viewStyle == "flat") {
              currentYPos = 0;
          }
          else {
            currentYPos = i * chunkHeight + 1 * i;
          }

          let positions;
          // complete repeats only
          if (props.clickedGenes[i]["complete"] === "yes" && props.completeFilter.includes("complete")) {
            positions = drawTrack(pg, props.clickedGenes[i], props.zoom, props.pan, minPos, currentYPos, chunkHeight, props.completeFilter);
          }
          // incomplete repeats only
          else if (props.clickedGenes[i]["complete"] === "no" && props.completeFilter.includes("fragment")){
            positions = drawTrack(pg, props.clickedGenes[i], props.zoom, props.pan, minPos, currentYPos, chunkHeight, props.completeFilter);
          }
          // all repeats
          else if (props.completeFilter.includes("all")) {
            positions = drawTrack(pg, props.clickedGenes[i], props.zoom, props.pan, minPos, currentYPos, chunkHeight, props.completeFilter);
          } 
          else {
            positions = [null, null]
          }

          //let positions = drawTrack(pg, props.clickedGenes[i], props.zoom, props.pan, minPos, currentYPos, chunkHeight, props.completeFilter);

          let info = {
            left: positions[0] - props.pan,
            top: currentYPos,
            width: positions[1],
            height: chunkHeight,
            clade: props.clickedGenes[i]["clade"],
            ogStart: props.clickedGenes[i]["start"],
            ogEnd: props.clickedGenes[i]["end"],
            unitig: props.clickedGenes[i]["unitig"],
            complete:props.clickedGenes[i]["complete"]
          };
          selectedNodes.push(info);
        }
        
        let temp = {genome: props.genome, positions: [...selectedNodes]}
        dispatch(changeCalculatedPositions(temp));
        //props.submitCalculatedPositions(selectedNodes, props.genome);

        pg.strokeWeight(1);
      }
      p.image(pg, 0, 0);
      drawScaleLineV2(p, [], canvasHeight - 10);
    };
  };

  useEffect(() => {
    let inst = new p5(Sketch, containerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps

    return () => inst.remove();
  }, [props.clickedGenes, props.clade, props.zoom, props.pan, props.viewStyle, props.completeFilter]);

  return <div ref={containerRef}></div>;
};
export default SubregionSelection;
